"use strict";
var Observable_1 = require('../../Observable');
var from_1 = require('../../observable/from');
Observable_1.Observable.from = from_1.from;
//# sourceMappingURL=from.js.map


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/_storageApp.Front.release/~/rxjs/add/observable/from.js
// module id = ../../../../rxjs/add/observable/from.js
// module chunks = 4